<app-nav></app-nav>
<section class="insurances-panel">
  <div class="container">
    <div class="col">
        <div class="panel panel-default"  *ngFor="let detail of insuranceDetails">
          <div class="panel-heading text-right insuranceCardEdit">
            <div class="editDots" routerLink="/editInsuranceDetails/{{detail._id}}">
              <i class="fas fa-circle text-white"></i><i class="fas fa-circle text-white"></i><i class="fas fa-circle text-white"></i>
            </div>
          </div>
          <div class="panel-body">
                <span *ngIf="detail.linkedToCard">
                    <div class="col-12 bg-panel-body">
                      <div class="row" *ngFor="let fieldDetails of detail.dynamic_fields">
                          <div class="col-4 textWrap">{{fieldDetails.name}} </div>
                          <div class="col-8 overText"><b>{{fieldDetails.value}}</b></div>
                      </div>
                    </div>
                </span>

                <span *ngIf="!detail.linkedToCard">
                  <div class="col-12 ">
                      <div class="row" *ngFor="let fieldDetails of detail.fields">
                          <div class="col-4 textWrap">{{transformName(fieldDetails.id)}} </div>
                          <div class="col-8 overText"><b>{{fieldDetails.value}}</b></div>
                      </div>
                  </div>
                </span>
                <div class="col-12">
              
                  <div class="row">
                      <div class="col-4 textWrap">Policy Type: </div>
                      <div class="col-8 overText"><b>{{detail.managerPolicyType}}</b></div>
                  </div>
              </div>
          </div>
        </div>
    </div>
  </div>
  <div id="spinner" [hidden]="!loading">
      <div class="spinnerfull">
          <i class="fa fa-spinner fa-spin fa-3x"></i>
      </div>
  </div>
</section>
